module.exports = ".dialog-action{\n    float: right;\n  }\n  \n  .btn{\n    border-radius: 0;\n  }\n  \n  .btn-primary {\n    background: #009688;\n  }\n  \n  .title{\n    /* padding: 0 20px; */\n    color: #009688\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/manager/delete-manager-dialog.css
// module id = ./src/app/manager/delete-manager-dialog.css
// module chunks = main